import React from 'react';
import { Reveal } from './Reveal';
import { CallVignette } from './CallVignette';
import { SmsVignette } from './SmsVignette';
import { CalendarVignette } from './CalendarVignette';
import { AgreementVignette } from './AgreementVignette';
import { CrmVignette } from './CrmVignette';
import { BrandButton } from '../BrandButton';
interface Vignette {
  step: string;
  headline: string;
  body: string;
  card: React.ReactNode;
}
const vignettes: Vignette[] = [{
  step: '01',
  headline: '9:42 PM. Your agents are done for the day. The phone is not.',
  body: 'The call gets answered live, on your script, and qualified before it ever becomes a voicemail.',
  card: <CallVignette data-id="element-370" data-mp="3rrir0h5zh8x3" />
}, {
  step: '02',
  headline: 'The form fill gets a text in under a minute.',
  body: 'Written leads get a real conversation while the buyer is still on the listing page, not a callback tomorrow.',
  card: <SmsVignette data-id="element-371" data-mp="2ub24sn4jjq2l" />
}, {
  step: '03',
  headline: 'It books the right agent, not just any agent.',
  body: 'Territory, availability, and your round robin decide who gets it, then the show-rate reminders start on their own.',
  card: <CalendarVignette data-id="element-372" data-mp="3sq0lg2hcx9lj" />
}, {
  step: '04',
  headline: 'The touring agreement is signed before the showing.',
  body: 'Since the NAR settlement, a signed buyer agreement comes before the tour. We send yours the moment the tour is booked, remind until it is signed, and flag anything unsigned before the showing. Your agents never chase paperwork again.',
  card: <AgreementVignette data-id="element-373" data-mp="39u25ek1kf1uv" />
}, {
  step: '05',
  headline: 'Your CRM gets the whole story.',
  body: 'Recording, transcript, qualification notes, appointment, and signed agreement, all written back into the system your team already uses.',
  card: <CrmVignette data-id="element-374" data-mp="u1v1g2yfw5ct" />
}];
export function LeadSavedShowcase() {
  return <section id="in-action" aria-labelledby="in-action-title" className="border-b border-white/5 bg-ink-900" data-id="element-375" data-mp="u3xoce4apidb">
      <div className="mx-auto max-w-content px-5 py-20 sm:px-8 sm:py-24" data-id="element-376" data-mp="2v3u7s9gebq1o">
        <Reveal data-id="element-377" data-mp="2v5x6dhvm6ri0">
          <p className="text-xs font-semibold uppercase tracking-[0.18em] text-brand" data-id="element-378" data-mp="2q59hp2uuymqy">
            Product in action
          </p>
          <h2 id="in-action-title" className="mt-5 max-w-2xl font-display text-3xl font-bold leading-tight tracking-tight text-white sm:text-4xl" data-id="element-379" data-mp="343pmgo95u36g">
            Watch a lead get saved.
          </h2>
          <p className="mt-5 max-w-2xl text-base leading-relaxed text-white/60" data-id="element-380" data-mp="2bgczwe301vd5">
            One after-hours Zillow call, start to finish. All demo data below is
            demonstrative.
          </p>
        </Reveal>

        <div className="mt-16 space-y-16 sm:mt-20 sm:space-y-24" data-id="element-381" data-mp="2l7r3awy2nfbk">
          {vignettes.map((vignette, index) => {
          const flipped = index % 2 === 1;
          return <div key={vignette.step} className="grid items-center gap-8 lg:grid-cols-2 lg:gap-14" data-id="element-382" data-mp="1snivge305ln6" data-mpi={index}>
                <Reveal className={flipped ? 'lg:order-2' : 'lg:order-1'} delay={0.05} data-id="element-383" data-mp="3885278x8mss">
                  {vignette.card}
                </Reveal>

                <Reveal className={flipped ? 'lg:order-1' : 'lg:order-2'} delay={0.12} data-id="element-384" data-mp="3qdz5gpu5g1t8">
                  <span className="font-display text-sm font-semibold tracking-widest text-brand" data-id="element-385" data-mp="3vciux07ybvqc">
                    {vignette.step}
                  </span>
                  <h3 className="mt-4 max-w-md font-display text-2xl font-bold leading-tight tracking-tight text-white sm:text-3xl" data-id="element-386" data-mp="qyc6q92juch5">
                    {vignette.headline}
                  </h3>
                  <p className="mt-4 max-w-md text-sm leading-relaxed text-white/60 sm:text-base" data-id="element-387" data-mp="hwl45d3b2lri">
                    {vignette.body}
                  </p>
                </Reveal>
              </div>;
        })}
        </div>

        <Reveal className="mt-16 border-t border-white/10 pt-10 sm:mt-20" data-id="element-388" data-mp="32owrbryq4r3h">
          <p className="max-w-2xl border-l-2 border-brand pl-5 font-display text-lg leading-relaxed text-white/85 sm:text-xl" data-id="element-389" data-mp="3hy1toopkb7kq">
            Every one of these happened while the team was at dinner.
          </p>
          <div className="mt-8" data-id="element-390" data-mp="395gaj7i0qyvd">
            <BrandButton label="Book your free Response Audit" size="lg" withArrow data-id="element-391" data-mp="392kh9wh48yd9" />
          </div>
        </Reveal>
      </div>
    </section>;
}